import { axios } from '@/utils/request'
import { filterData } from '@/utils/util'

const api = {
  listhistory: `/whitelist/listhistory`,
  remove: `/whitelist/remove`,
  list: `/whitelist/list`,
  add: `/whitelist/add`,
}

// 查看历史
export function listhistory (params) {
  return axios({
    url: api.listhistory,
    method: 'get',
    params: filterData(params),
    func:'查看历史'
  })
}

// 移除
export function removeItem (data) {
  return axios({
    url: api.remove,
    method: 'post',
    data: filterData(data),
    func:'移除'
  })
}

// 查询名单列表
export function queryList (params) {
  return axios({
    url: api.list,
    method: 'get',
    params: filterData(params),
    func:'查询白名单列表'
  })
}
//新增
export function addItem (data) {
  return axios({
    url: api.add,
    method: 'post',
    data: filterData(data),
    func:'新增'
  })
}

